/**
 * 事故距离统计
 */
import { ACCIDENTDISTANCESTATISTICS } from '../types';

export default {
    name: `${ACCIDENTDISTANCESTATISTICS}`,
    path: '/accidentDistanceStatistics',
    component: () => import(/* webpackChunkName: 'accidentDistanceStatistics' */ '@/views/accidentDistanceStatistics/'),
    redirect: { name: `${ACCIDENTDISTANCESTATISTICS}Index` },
    meta: {
        title: '事故距离统计',
        savedPosition: { x: 0, y: 0 },
        noCache: true,
    },
    children: [
        {
            name: `${ACCIDENTDISTANCESTATISTICS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'accidentDistanceStatistics' */ '@/views/accidentDistanceStatistics/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${ACCIDENTDISTANCESTATISTICS}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'accidentDistanceStatistics' */ '@/views/accidentDistanceStatistics/detail/Detail.vue'),
        // },
    ],
};
